export const styles: { [x: string]: { [y: string]: any } } = {
    modalContent: {
        marginTop: [4, 4],
        // We need to overwrite each breakpoint value from the Modal component
        marginBottom: [0, 4, 4, 6],
        mx: [0, 3, 3, 6],
        boxShadow: "fromBottom",
        backdropFilter: `blur(7.5px)`,
        p: [0, 0, 0, 0],
        pl: [0, 0, 6, 0],
        maxW: ["100%", "100%", "100%", "480px"],
        w: ["100%", "100%", "100%", "auto"],
        gap: 0,
        "@media (orientation: landscape)": {
            marginBottom: [3, 6],
        },
        position: ["relative", "relative", "absolute"],
        right: 0,
        bottom: "100%",
        backgroundColor: "none",
    },
    productDataContainer: {
        bg: "white",
        display: { base: "none", lg: "flex" },
        h: "125px",
        mb: "1px",
        gap: 6,
    },
    submitContainer: {
        w: "100%",
        gap: "0.2",
    },
    submitButton: {
        w: "100%",
        bg: "black",
        color: "white",
    },
};
